export default __webpack_public_path__ + "static/media/title.0cc59f90.svg";